<div *ngIf="checkViewMode('edit')">
  <div class="form-group">
    <label>{{ getDocumentTitle() }}
      <span *ngIf="isRequiredDocument && isErrorTopDocument" class="error error-top">{{ getErrorOnTopCompany() }}</span>
      <span *ngIf="isRequired() && documentAttr && !documentAttr.value" class="error-indication">*</span>
    </label>

    <input *ngIf="documentAttr" class="form-control"
      [class.has-error]="documentAttr.hasError"
      [id]="getOptionByKey(documentAttr,'identifier')"
      type="text"
      [required]="getOptionByKey(attribute,'required')"
      [(ngModel)]="documentAttr.value"
      [maxlength]="getOptionByKey(documentAttr,'maxlength')"
      [placeholder]="getOptionByKey(documentAttr,'placeholder')"
      (input)="onValueChange($event)"
      [mask]="getDocumentMask()">
      <span *ngIf="isRequiredDocument && !isErrorTopDocument" class="error">Este campo é obrigatório</span>
  </div>

  <ng-container *ngIf="companyModel || hasFieldsFilled || (showFieldsOnError && hasLookupError)">
    <app-dynamic *ngFor="let attr of companyFields"
      [attribute]="attr"
      [process]="process"
      [parent]="attribute"
      [envOptions]="envOptions"
      (onEmit)="onDynamicEmit($event)"
      [@fadeAnimation]>
    </app-dynamic>
  </ng-container>
</div>

<div *ngIf="checkViewMode('view')">
  <p><span>{{attribute.key}}:</span> {{documentAttr.value | mask: "99.999.999/9999-99" }}</p>
  <ng-container *ngIf="companyModel || hasFieldsFilled || (showFieldsOnError && hasLookupError)">
    <app-dynamic *ngFor="let attr of companyFields"
      [attribute]="attr"
      [process]="process"
      [parent]="attribute"
      [envOptions]="envOptions"
      (onEmit)="onDynamicEmit($event)"
      [@fadeAnimation]>
    </app-dynamic>
  </ng-container>
</div>
